module.exports = __webpack_public_path__ + "img/image_022.f5ffb177.jpg";